import type { Account } from "@/lib/finance";
import { money, moneyIn, rateText } from "@/lib/format";

export function FxBalance({ a, className = "" }: { a: Account; className?: string }) {
  return (
    <span className={`flex flex-col items-end ${className}`}>
      <span className={`tabular font-semibold ${a.current_balance < 0 ? "text-[#B23A1E]" : a.is_liability ? "text-[#1B6E4F]" : "text-[#1B2A4A]"}`} data-testid={`account-balance-${a.id}`}>
        {moneyIn(a.current_balance, a.currency)}
      </span>
      {a.currency !== "MXN" && (
        <span className="tabular whitespace-nowrap text-[11px] font-normal text-slate-500" data-testid={`account-balance-mxn-${a.id}`}>
          ≈ {money(a.balance_mxn)} MXN{a.fx_rate ? ` · TC ${rateText(a.fx_rate)}` : " · sin tipo de cambio"}
        </span>
      )}
    </span>
  );
}
